"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9542],{

/***/ 70650:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ common_ArticleListItem; }
});

// UNUSED EXPORTS: ArticleKeywordWrapper

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(61953);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(61225);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/useTheme.js
var useTheme = __webpack_require__(62097);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 3 modules
var emotion_styled_browser_esm = __webpack_require__(77366);
// EXTERNAL MODULE: ./components/common/A/index.js
var A = __webpack_require__(79592);
// EXTERNAL MODULE: ./components/common/NowrapDiv/index.js
var NowrapDiv = __webpack_require__(2925);
// EXTERNAL MODULE: ./components/common/TagButton/index.js
var TagButton = __webpack_require__(25133);
// EXTERNAL MODULE: ./components/common/SVGElements/Pen.js
var Pen = __webpack_require__(79193);
// EXTERNAL MODULE: ./components/common/SVGElements/Eye.js
var Eye = __webpack_require__(23183);
// EXTERNAL MODULE: ./components/common/VenderLink/index.js
var VenderLink = __webpack_require__(90879);
// EXTERNAL MODULE: ./utils/request.js
var request = __webpack_require__(72673);
;// CONCATENATED MODULE: ./utils/api/general/setArticleClicked.js

const setArticleClicked = (articleId)=>{
    return (0,request/* safeAwait */.Ev)((0,request/* lsPut */.OL)("/articles/".concat(articleId, "/clicks")));
};

;// CONCATENATED MODULE: ./components/common/ArticleListItem/index.js

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  // 子元素保持原本的寬度，不被壓縮\n  & > * {\n    flex-shrink: 0;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  padding-top: 75%;\n  width: 120px;\n  ",
        "\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 12px;\n  background: url('/img/img_headshot_default.png');\n  background-size: 100%;\n  background-position: center;\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-overflow: ellipsis;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  display: none;\n  ",
        "\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}












const ArticleKeywordWrapper = (0,emotion_styled_browser_esm/* default */.Z)(Box/* default */.Z)(_templateObject());
const ImgRect = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject1(), (param)=>{
    let { theme  } = param;
    return "\n    ".concat(theme.breakpoints.up("lg"), " {\n      width: 196px;\n    }\n    ").concat(theme.breakpoints.up("xl"), " {\n      width: 240px;\n    }\n  ");
});
const Absolute = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject2());
const Img = emotion_styled_browser_esm/* default.img */.Z.img(_templateObject3());
const ArticleSummary = (0,emotion_styled_browser_esm/* default */.Z)(Typography/* default */.Z)(_templateObject4(), (param)=>{
    let { theme , $usedInVenderPage  } = param;
    return "\n    ".concat(theme.breakpoints.up($usedInVenderPage ? "xs" : "md"), " {\n      display: -webkit-box;\n      -webkit-line-clamp: 2;\n    }\n    ").concat(theme.breakpoints.up("xl"), " {\n      -webkit-line-clamp: 3;\n    }\n  ");
});
const ArticleListItem = (param)=>{
    let { article , usedInVenderPage  } = param;
    var _article_vender, _article_vender_introductionInfo, _article_keywords;
    const theme = (0,useTheme/* default */.Z)();
    const isMedium = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down("md"));
    const isLarge = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up("lg"));
    const image = (article === null || article === void 0 ? void 0 : article.mediumImage) || (article === null || article === void 0 ? void 0 : article.image);
    const url = "/article/".concat(article === null || article === void 0 ? void 0 : article.urlId);
    var _article_publicViews;
    const articleViews = (_article_publicViews = article === null || article === void 0 ? void 0 : article.publicViews) !== null && _article_publicViews !== void 0 ? _article_publicViews : 0;
    const handleArticleClick = (event)=>{
        var _event_target, _event_target_closest;
        if (usedInVenderPage || !(article === null || article === void 0 ? void 0 : article._id)) return;
        // 避免把點擊作者/標籤誤算成點擊文章
        const clickedLink = (_event_target_closest = (_event_target = event.target).closest) === null || _event_target_closest === void 0 ? void 0 : _event_target_closest.call(_event_target, "a");
        if (clickedLink && clickedLink !== event.currentTarget) return;
        setArticleClicked(article._id);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(A/* default */.Z, {
        href: url,
        $origin: true,
        target: "_blank",
        onClick: handleArticleClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            display: "flex",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgRect, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Absolute, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Img, {
                                src: image === null || image === void 0 ? void 0 : image.url
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    ml: {
                        xs: 4,
                        xl: 5,
                        xxl: 6
                    },
                    flex: 1,
                    minWidth: 0,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            sx: {
                                typography: {
                                    xs: "titleLarge",
                                    lg: "headlineSmall",
                                    xxl: "headlineMedium"
                                }
                            },
                            color: "textPrimary",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NowrapDiv/* default */.Z, {
                                $lines: 2,
                                children: article === null || article === void 0 ? void 0 : article.title
                            })
                        }),
                        !!(article === null || article === void 0 ? void 0 : article.summary) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleSummary, {
                            sx: {
                                typography: {
                                    xs: "paraBodySmall",
                                    xl: "paraBodyMedium"
                                }
                            },
                            color: "textSecondary",
                            $usedInVenderPage: usedInVenderPage,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                mt: 1,
                                children: article === null || article === void 0 ? void 0 : article.summary
                            })
                        }),
                        !(usedInVenderPage && !isLarge) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(TagButton/* OneLineGrid */.$, {
                            container: true,
                            spacing: 4,
                            ml: 0,
                            $height: isMedium ? "auto" : "35px",
                            $width: "100%",
                            mt: 3,
                            flexWrap: "nowrap",
                            children: [
                                !usedInVenderPage && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    display: "inline-flex",
                                    alignItems: "center",
                                    mb: 1,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            mr: 4,
                                            display: "flex",
                                            flexWrap: "nowrap",
                                            alignItems: "center",
                                            children: (article === null || article === void 0 ? void 0 : (_article_vender = article.vender) === null || _article_vender === void 0 ? void 0 : (_article_vender_introductionInfo = _article_vender.introductionInfo) === null || _article_vender_introductionInfo === void 0 ? void 0 : _article_vender_introductionInfo.isVisible) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VenderLink/* default */.Z, {
                                                vender: article === null || article === void 0 ? void 0 : article.vender,
                                                width: isMedium ? "16px" : "20px",
                                                height: isMedium ? "16px" : "20px"
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                display: "flex",
                                                alignItems: "center",
                                                flexWrap: "nowrap",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Pen/* PenSVG */.m, {
                                                        width: isMedium ? "16px" : "20px",
                                                        height: isMedium ? "16px" : "20px",
                                                        $color: "text.disabled"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        ml: 1.5,
                                                        color: "text.disabled",
                                                        sx: {
                                                            typography: {
                                                                xs: "bodyXs",
                                                                md: "bodySmall"
                                                            }
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NowrapDiv/* default */.Z, {
                                                            children: article === null || article === void 0 ? void 0 : article.byline
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                            mr: 4,
                                            display: "flex",
                                            alignItems: "center",
                                            flexWrap: "nowrap",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Eye/* EyeSVG */.P, {
                                                    width: isMedium ? "16px" : "20px",
                                                    height: isMedium ? "16px" : "20px",
                                                    $color: "text.disabled"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    ml: 1.5,
                                                    color: "text.disabled",
                                                    sx: {
                                                        typography: {
                                                            xs: "bodyXs",
                                                            md: "bodySmall"
                                                        }
                                                    },
                                                    children: articleViews
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                !!(article === null || article === void 0 ? void 0 : (_article_keywords = article.keywords) === null || _article_keywords === void 0 ? void 0 : _article_keywords.length) && isLarge && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleKeywordWrapper, {
                                    children: article.keywords.map((keyword, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            display: "inline-block",
                                            mr: 2,
                                            mb: 1,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TagButton/* default */.Z, {
                                                href: "/article/tag/".concat(keyword.urlId),
                                                size: "sm",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NowrapDiv/* default */.Z, {
                                                    children: keyword.name
                                                })
                                            })
                                        }, index))
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var common_ArticleListItem = (ArticleListItem);


/***/ }),

/***/ 69443:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61953);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77366);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}


const CursorBox = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (CursorBox);


/***/ }),

/***/ 20293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ Dashed; },
/* harmony export */   "D": function() { return /* binding */ Solid; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61953);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77366);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}


const Dashed = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_templateObject(), (param)=>{
    let { theme  } = param;
    return "\n    border-top: 1px dashed ".concat(theme.palette.background.line, ";\n  ");
});
const Solid = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_templateObject1(), (param)=>{
    let { theme  } = param;
    return "\n    border-top: 1px solid ".concat(theme.palette.background.line, ";\n  ");
});


/***/ }),

/***/ 26710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ common_GuessLikesList; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(79072);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 3 modules
var emotion_styled_browser_esm = __webpack_require__(77366);
// EXTERNAL MODULE: ./utils/api/hooks/useGuessLikesByArticle.js
var useGuessLikesByArticle = __webpack_require__(15120);
// EXTERNAL MODULE: ./utils/hooks/fetchers.js
var fetchers = __webpack_require__(86700);
;// CONCATENATED MODULE: ./utils/api/hooks/useGuessLikesByArticleClassification.js

const useGuessLikesByArticleClassification = (articleClassificationId)=>{
    const genUrl = ()=>articleClassificationId ? "/articleClassifications/".concat(articleClassificationId, "/guessLike") : null;
    return (0,fetchers/* useCustomSWR */.LW)(genUrl);
};

// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__(80129);
;// CONCATENATED MODULE: ./utils/api/hooks/useGuessLikesByKeyword.js


const useGuessLikesByKeyword = function() {
    let keywordIds = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    const genUrl = ()=>{
        return (keywordIds === null || keywordIds === void 0 ? void 0 : keywordIds.length) ? "/articles/guessLike?".concat((0,lib.stringify)({
            keywordIds
        }, {
            arrayFormat: "repeat"
        })) : null;
    };
    return (0,fetchers/* useCustomSWR */.LW)(genUrl);
};

// EXTERNAL MODULE: ./components/common/A/index.js
var A = __webpack_require__(79592);
// EXTERNAL MODULE: ./components/common/CursorPointerBox.js/index.js
var CursorPointerBox_js = __webpack_require__(69443);
;// CONCATENATED MODULE: ./components/common/GuessLikesList/index.js

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 105px;\n  height: 79px;\n  min-width: 105px;\n  min-height: 79px;\n  border-radius: 12px;\n  overflow: hidden;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n  width: 100%;\n  object-fit: cover;\n  background: url('/img/img_headshot_default.png');\n  background-size: 100%;\n  background-position: center;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}







const GuessLikeImgWrapper = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject());
const GuessLikeImg = emotion_styled_browser_esm/* default.img */.Z.img(_templateObject1());
const GuessLikes = (param)=>{
    let { guessLikeData , isGuessLikeLoading , ...prop } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: !!(guessLikeData === null || guessLikeData === void 0 ? void 0 : guessLikeData.length) && !isGuessLikeLoading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
            container: true,
            ...prop,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    mb: 6,
                    fontWeight: "fontWeightBold",
                    children: "猜你喜歡"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xs: 12,
                    children: guessLikeData && (guessLikeData === null || guessLikeData === void 0 ? void 0 : guessLikeData.map((item, index)=>{
                        var _item_image;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(A/* default */.Z, {
                            href: "/article/".concat(item === null || item === void 0 ? void 0 : item.urlId),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CursorPointerBox_js/* default */.Z, {
                                display: "flex",
                                alignItems: "center",
                                mb: index < guessLikeData.length - 1 ? 6 : 0,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GuessLikeImgWrapper, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GuessLikeImg, {
                                            src: item === null || item === void 0 ? void 0 : (_item_image = item.image) === null || _item_image === void 0 ? void 0 : _item_image.url
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "paraBodyMedium",
                                        color: "text.minus2",
                                        ml: 3,
                                        children: item === null || item === void 0 ? void 0 : item.title
                                    })
                                ]
                            })
                        }, item === null || item === void 0 ? void 0 : item.urlId);
                    }))
                })
            ]
        }) : null
    });
};
const GuessLikesList = (param)=>{
    let { article , articleClassification , keyword , ...props } = param;
    let guessLikeData;
    let isGuessLikeLoading;
    if (article === null || article === void 0 ? void 0 : article._id) {
        const { data , isLoading  } = (0,useGuessLikesByArticle/* useGuessLikesByArticle */.a)(article === null || article === void 0 ? void 0 : article._id);
        guessLikeData = data;
        isGuessLikeLoading = isLoading;
    } else if (articleClassification === null || articleClassification === void 0 ? void 0 : articleClassification._id) {
        const { data: data1 , isLoading: isLoading1  } = useGuessLikesByArticleClassification(articleClassification === null || articleClassification === void 0 ? void 0 : articleClassification._id);
        guessLikeData = data1;
        isGuessLikeLoading = isLoading1;
    } else if (keyword) {
        const { data: data2 , isLoading: isLoading2  } = useGuessLikesByKeyword(keyword);
        guessLikeData = data2;
        isGuessLikeLoading = isLoading2;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GuessLikes, {
        guessLikeData: guessLikeData,
        isGuessLikeLoading: isGuessLikeLoading,
        ...props
    });
};
/* harmony default export */ var common_GuessLikesList = (GuessLikesList);


/***/ }),

/***/ 26643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77366);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var utils_hooks_dom__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(53258);
/* harmony import */ var use_deep_compare_effect__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87620);
/* harmony import */ var utils_hooks__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(13946);
/* harmony import */ var components_common_ScrollToTopButton__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(98780);
/*
 * 配合react-infinite-scroll-component使用
 * 當需要scrollableTarget時(在element scroll而不是window)
 * 須給定element實際的height pixel
 */ 
function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  overflow-y: hidden;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  height: ",
        "px;\n  overflow-y: auto;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}








const Container = _emotion_styled__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div */ .Z.div(_templateObject());
const HeightSyncToContainer = _emotion_styled__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div */ .Z.div(_templateObject1(), (props)=>props.height);
const InfiniteContainer = (param)=>{
    let { children , id , containerRef , filterState ={} , ...rest } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const { page  } = (router === null || router === void 0 ? void 0 : router.query) || {};
    const [node, nodeRef] = (0,utils_hooks_dom__WEBPACK_IMPORTED_MODULE_5__/* .useStateRef */ .Y)();
    const [height, setHeight] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)();
    const scrollableRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    const { showButton , showScrollButton  } = (0,utils_hooks__WEBPACK_IMPORTED_MODULE_7__/* .useShowScrollToTopButton */ .zi)();
    // 判斷當有頁面 query 且改變時為點擊換頁，使頁面置頂
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if ((router === null || router === void 0 ? void 0 : router.pathname) === "/vender" && page) {
            setTimeout(()=>{
                var _scrollableRef_current;
                return (scrollableRef === null || scrollableRef === void 0 ? void 0 : scrollableRef.current) && (scrollableRef === null || scrollableRef === void 0 ? void 0 : (_scrollableRef_current = scrollableRef.current) === null || _scrollableRef_current === void 0 ? void 0 : _scrollableRef_current.scrollTo({
                    top: 0,
                    behavior: "smooth"
                }));
            }, 0);
        }
    }, [
        page,
        filterState
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if ((scrollableRef === null || scrollableRef === void 0 ? void 0 : scrollableRef.current) && containerRef) {
            containerRef.current = scrollableRef === null || scrollableRef === void 0 ? void 0 : scrollableRef.current;
        }
    }, [
        scrollableRef === null || scrollableRef === void 0 ? void 0 : scrollableRef.current,
        containerRef
    ]);
    const handleResize = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(()=>{
        if (node) {
            setHeight(node.clientHeight);
        }
    }, [
        node
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (!node) {
            return;
        }
        const observer = new ResizeObserver(handleResize);
        observer.observe(node);
        return ()=>{
            observer.unobserve(node);
        };
    }, [
        node,
        handleResize
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Container, {
        ref: nodeRef,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(HeightSyncToContainer, {
            height: height,
            id: id,
            ref: scrollableRef,
            onScroll: showScrollButton,
            children: [
                children,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_ScrollToTopButton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    showButton: showButton,
                    scrollableRef: scrollableRef
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (InfiniteContainer);


/***/ }),

/***/ 87624:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(29630);
/* harmony import */ var _mui_material_Grid__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(79072);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77366);
/* harmony import */ var utils_api_hooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(56168);
/* harmony import */ var components_common_A__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79592);
/* harmony import */ var components_common_CursorPointerBox_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69443);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 105px;\n  height: 79px;\n  min-width: 105px;\n  min-height: 79px;\n  border-radius: 5px;\n  overflow: hidden;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 12px;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}







const ImgRect = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject());
const Img = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].img */ .Z.img(_templateObject1());
const LatestArticle = (prop)=>{
    const { data: articles , isLoading: isArticleLoading  } = (0,utils_api_hooks__WEBPACK_IMPORTED_MODULE_5__/* .useArticles */ .l)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: !isArticleLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
            container: true,
            mb: 12,
            ...prop,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    mb: 6,
                    fontWeight: "fontWeightBold",
                    children: "最新上架"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
                    item: true,
                    xs: 12,
                    children: articles && (articles === null || articles === void 0 ? void 0 : articles.slice(0, 3).map((item, index)=>{
                        var _item_image;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_A__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            href: "/article/".concat(item === null || item === void 0 ? void 0 : item.urlId),
                            target: "_blank",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(components_common_CursorPointerBox_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                display: "flex",
                                alignItems: "center",
                                mb: index < articles.length - 1 ? 6 : 0,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ImgRect, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Img, {
                                            alt: "",
                                            src: ((_item_image = item.image) === null || _item_image === void 0 ? void 0 : _item_image.url) || "/img/img_headshot_default.png"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                        variant: "paraBodyMedium",
                                        color: "text.minus2",
                                        mt: 3,
                                        mx: 2,
                                        children: item === null || item === void 0 ? void 0 : item.title
                                    })
                                ]
                            })
                        }, item._id);
                    }))
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LatestArticle);


/***/ }),

/***/ 84070:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var config_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73221);



const NoindexRemoval = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
            children: config_constants__WEBPACK_IMPORTED_MODULE_2__/* .APP_ENV */ .Wi === "prod" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {}, "noindex")
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NoindexRemoval);


/***/ }),

/***/ 2925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77366);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-overflow: ellipsis;\n  overflow: hidden;\n  ",
        ";\n  line-height: ",
        ";\n  height: ",
        ";\n  text-align: ",
        ";\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}

const NowrapDiv = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject(), (param)=>{
    let { $lines  } = param;
    return !!$lines && $lines > 1 ? "display: -webkit-box;" + "-webkit-line-clamp: ".concat($lines, ";") + "-webkit-box-orient: vertical;" : "white-space: nowrap;";
}, (param)=>{
    let { $fixHeight  } = param;
    return $fixHeight ? "1.2em" : "";
}, (param)=>{
    let { $lines , $fixHeight  } = param;
    return $fixHeight ? ($lines || 1) * 1.2 + "em" : "auto";
}, (param)=>{
    let { $textCenter  } = param;
    return $textCenter ? "center" : "left";
});
/* harmony default export */ __webpack_exports__["Z"] = (NowrapDiv);


/***/ }),

/***/ 23183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ EyeSVG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _SVG__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54806);


const EyeSVG = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SVG__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
            className: "btn_eye_off",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    d: "M2.14 12a18.68 18.68 0 002.464 3.316C6.397 17.226 8.9 19 12 19c3.1 0 5.605-1.774 7.395-3.684A18.684 18.684 0 0021.86 12a18.681 18.681 0 00-2.464-3.316C17.605 6.774 15.101 5 12 5 8.9 5 6.396 6.774 4.605 8.684A18.678 18.678 0 002.14 12zM23 12l.894-.448-.002-.003-.003-.007-.011-.022a10.615 10.615 0 00-.192-.354 20.675 20.675 0 00-2.831-3.85C18.895 5.226 15.899 3 12 3 8.1 3 5.104 5.226 3.145 7.316a20.674 20.674 0 00-2.831 3.85 12.375 12.375 0 00-.192.354l-.011.022-.003.007-.002.002s0 .002.894.449l-.894-.447a1 1 0 000 .894L1 12l-.894.447.002.004.003.007.011.022a8.267 8.267 0 00.192.354 20.67 20.67 0 002.831 3.85C5.105 18.774 8.1 21 12 21c3.9 0 6.895-2.226 8.855-4.316a20.672 20.672 0 002.831-3.85 11.81 11.81 0 00.192-.354l.011-.022.003-.007.002-.002s0-.002-.894-.449zm0 0l.894.447c.141-.281.14-.613 0-.895L23 12z",
                    className: "Vector (Stroke)",
                    clipRule: "evenodd"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    d: "M12 10a2 2 0 100 4 2 2 0 000-4zm-4 2a4 4 0 118 0 4 4 0 01-8 0z",
                    className: "Vector (Stroke)_2",
                    clipRule: "evenodd"
                })
            ]
        })
    });
};


/***/ }),

/***/ 79193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ PenSVG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _SVG__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54806);


const PenSVG = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SVG__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            className: "pen-tool",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                d: "M2.235 1.028a1 1 0 00-1.207 1.207l3.5 14.5a1 1 0 00.776.746l5.765 1.153a1 1 0 00.224 1.073l3 3a1 1 0 001.414 0l7-7a1 1 0 000-1.414l-3-3a1 1 0 00-1.073-.224L17.48 5.304a1 1 0 00-.746-.776l-14.5-3.5zm11.467 17.685l.005-.006 5-5 .006-.005.287-.288L20.586 15 15 20.586 13.414 19l.288-.287zm3.213-6.042l-1.27-6.349L5.22 3.806l4.487 4.486a3 3 0 11-1.414 1.414L3.805 5.22l2.516 10.425 6.35 1.27 4.242-4.244zM10 11a1 1 0 112 0 1 1 0 01-2 0z",
                className: "Union",
                clipRule: "evenodd"
            })
        })
    });
};


/***/ }),

/***/ 25133:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ OneLineGrid; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _mui_material_Button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75084);
/* harmony import */ var _mui_material_Grid__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79072);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29630);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77366);
/* harmony import */ var components_common_A__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79592);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: ",
        ";\n  width: ",
        ";\n  overflow-y: hidden;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}






const OneLineGrid = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_templateObject(), (param)=>{
    let { $height  } = param;
    return $height || "72px";
}, (param)=>{
    let { $width  } = param;
    return $width;
});
const StyledButton = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_material_Button__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_templateObject1(), (param)=>{
    let { theme , size , shape  } = param;
    return "\n    border-radius: 25px;\n    font-size: 14px;\n    color: ".concat(theme.palette.text.minus2, ";\n    background: ").concat(theme.palette.grey.third, ";\n    padding: ").concat({
        sm: "10px 12px",
        md: "10px 16px",
        lg: "12px 20px",
        xl: "12px 20px"
    }[size], ";\n    border-radius: ").concat({
        round: "20px",
        rectangle: "6px"
    }[shape], "\n\n    &:hover {\n      background-color: ").concat(theme.palette.primary.bgPlus1, ";\n      box-shadow: none; // shadow override worked here only in ios browser\n    }\n    &:active {\n      background-color: ").concat(theme.palette.primary.main, ";\n      color: #ffffff;\n    }\n  ");
});
const TagButton = (param)=>{
    let { href , children , shape ="round" , size ="md" , ...rest } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_A__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        href: href || "",
        $origin: true,
        ...rest,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledButton, {
            variant: "contained",
            color: "grey",
            shape: shape,
            size: size,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                sx: {
                    typography: {
                        sm: "bodyXs",
                        md: "bodySmall",
                        lg: "bodyMedium",
                        xl: "bodyLarge"
                    }[size]
                },
                children: children
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TagButton);


/***/ }),

/***/ 90879:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61953);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29630);
/* harmony import */ var components_common_SVGElements__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79193);
/* harmony import */ var components_common_A__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79592);
/* harmony import */ var components_common_NowrapDiv__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2925);






const VenderLink = (param)=>{
    let { vender , ...props } = param;
    if (!vender) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_A__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        href: "/vender/".concat(vender === null || vender === void 0 ? void 0 : vender.urlId),
        $color: "text.minus2",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            display: "flex",
            alignItems: "center",
            flexWrap: "nowrap",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_SVGElements__WEBPACK_IMPORTED_MODULE_4__/* .PenSVG */ .m, {
                    $color: "text.disabled",
                    ...props
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    ml: 1.5,
                    color: "text.disabled",
                    sx: {
                        typography: {
                            xs: "bodyXs",
                            md: "bodySmall"
                        }
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_NowrapDiv__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        children: vender === null || vender === void 0 ? void 0 : vender.shortname
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (VenderLink);


/***/ }),

/***/ 92437:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ useArticleClassifications; }
/* harmony export */ });
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var utils_hooks_fetchers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86700);


const useArticleClassifications = function() {
    let props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        limit: 999
    }, swrOptions = arguments.length > 1 ? arguments[1] : void 0;
    return (0,utils_hooks_fetchers__WEBPACK_IMPORTED_MODULE_1__/* .useCustomSWR */ .LW)("/articleClassifications?".concat((0,qs__WEBPACK_IMPORTED_MODULE_0__.stringify)(props)), swrOptions);
};


/***/ }),

/***/ 56168:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ useArticles; }
/* harmony export */ });
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var utils_hooks_fetchers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86700);


const useArticles = (props, swrOptions)=>{
    const genUrl = ()=>{
        try {
            const propsObject = typeof props === "function" ? props() : props;
            if (propsObject === null) {
                return null;
            }
            return "/articles?".concat((0,qs__WEBPACK_IMPORTED_MODULE_0__.stringify)(propsObject));
        } catch (err) {
            return null;
        }
    };
    return (0,utils_hooks_fetchers__WEBPACK_IMPORTED_MODULE_1__/* .useCustomSWR */ .LW)(genUrl, swrOptions);
};


/***/ }),

/***/ 13929:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ useBanners; }
/* harmony export */ });
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var utils_hooks_fetchers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86700);
/* harmony import */ var utils_request__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72673);



const useBanners = function(webviewName) {
    let displayOpt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, swrOptions = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const defaultSwrOptions = {
        revalidateOnFocus: false
    } // 由於 banner 加入隨機排序設定，所以不在 focus 時重新抓取，以免影響使用者體驗
    ;
    const visibleSource = !webviewName ? "lsWeb" : webviewName;
    const genUrl = ()=>{
        const getBannersUrl = "/banners/client?";
        let getBannersUrlQueryData = {
            visibleSource,
            displayAt: "homepage"
        };
        if (displayOpt) getBannersUrlQueryData = {
            ...getBannersUrlQueryData,
            ...displayOpt
        };
        return "".concat(getBannersUrl).concat((0,qs__WEBPACK_IMPORTED_MODULE_0__.stringify)(getBannersUrlQueryData));
    };
    return (0,utils_hooks_fetchers__WEBPACK_IMPORTED_MODULE_1__/* .useCustomSWR */ .LW)(genUrl, utils_request__WEBPACK_IMPORTED_MODULE_2__/* .lsGet */ .UY, {
        ...defaultSwrOptions,
        ...swrOptions
    });
};


/***/ }),

/***/ 15120:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ useGuessLikesByArticle; }
/* harmony export */ });
/* harmony import */ var utils_hooks_fetchers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86700);

const useGuessLikesByArticle = (articleId)=>{
    const genUrl = ()=>articleId ? "/articles/".concat(articleId, "/guessLike") : null;
    return (0,utils_hooks_fetchers__WEBPACK_IMPORTED_MODULE_0__/* .useCustomSWR */ .LW)(genUrl);
};


/***/ }),

/***/ 68138:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ useInfiniteArticles; }
/* harmony export */ });
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var utils_hooks_fetchers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86700);


const useInfiniteArticles = (props, swrOptions)=>{
    const getArticlesKey = (opts)=>(pageIndex, previousPageData)=>{
            const propsObject = typeof opts === "function" ? opts() : opts;
            if (propsObject === null) {
                return null;
            }
            if (previousPageData && !previousPageData.length) {
                return null;
            }
            const params = {
                ...propsObject,
                skip: pageIndex * (propsObject.limit || 20),
                limit: propsObject.limit || 20
            };
            return "/articles?".concat((0,qs__WEBPACK_IMPORTED_MODULE_0__.stringify)(params));
        };
    const { data , ...rest } = (0,utils_hooks_fetchers__WEBPACK_IMPORTED_MODULE_1__/* .useCustomSWRInfinite */ .KU)(getArticlesKey(props), swrOptions);
    // data會無預期出現數字，不確定為什麼，
    // 先避免直接回傳錯誤的資料類型
    return {
        data: typeof data === "number" ? [] : data,
        ...rest
    };
};


/***/ })

}]);